import { Channel } from "@anycable/web";

export default class AdminTimeClockChannel extends Channel {
  static identifier = "Admins::TimeClockChannel";

  receive(message) {
    if (message.user_id) {
      // Broadcasts an action when any employee in a tenants clock-in/clock-out status changes
      return this.emit("tenant-clock-in-status-change", message);
    }

    // Fallback to the default behaviour
    super.receive(message);
  }
}
